import "./resume_page.scss";
      const mappedNames = {"resume":"_resume_12sgn_11","header":"_header_12sgn_44","id":"_id_12sgn_59","contact":"_contact_12sgn_79","section":"_section_12sgn_84","section-head":"_section-head_12sgn_96","experiences":"_experiences_12sgn_117","details":"_details_12sgn_134","experience-head":"_experience-head_12sgn_137","team":"_team_12sgn_151","time":"_time_12sgn_155","education":"_education_12sgn_160","title":"_title_12sgn_160","school":"_school_12sgn_163","date":"_date_12sgn_166","skill-sets":"_skill-sets_12sgn_170","skills":"_skills_12sgn_175","volunteering":"_volunteering_12sgn_197"};

      function mapName(name) {
        if (!(name in mappedNames)) {
          // throw new Error("Unknown class name '" + name + "'.");
          return null;
        }

        return mappedNames[name];
      }

      export default function(...args) {
        const results = [];
        for (const arg of args) {
          if (typeof arg === "string") {
            const mappedName = mapName(arg);
            if (mappedName) results.push(mappedName);
          } else if (typeof arg === "object") {
            for (const [name, active] of Object.entries(arg)) {
              const mappedName = mappedNames[name];
              if (active && mappedName) results.push(mappedName);
            }
          }
        }

        return results.join(" ");
      }
      